/** Shared WebSocket protocol between the Curva editor bridge and the local MCP host. */

export const MCP_BRIDGE_PORT = 8421;
export const MCP_BRIDGE_URL = `ws://127.0.0.1:${MCP_BRIDGE_PORT}`;
export const MCP_PROTOCOL_VERSION = 1;

/** Editor → host */
export type McpBridgeClientMessage =
  | {
    type: "hello";
    protocolVersion: number;
    client: "curva-editor";
    appVersion: string;
  }
  | {
    type: "ping";
    t: number;
  }
  | {
    type: "response";
    id: string;
    ok: true;
    result: unknown;
  }
  | {
    type: "response";
    id: string;
    ok: false;
    error: string;
  };

/** Host → editor */
export type McpBridgeHostMessage =
  | {
    type: "welcome";
    protocolVersion: number;
    sessionId: string;
  }
  | {
    type: "pong";
    t: number;
  }
  | {
    type: "error";
    message: string;
  }
  | {
    type: "request";
    id: string;
    method: string;
    params?: unknown;
  };

export type McpBridgeMessage = McpBridgeClientMessage | McpBridgeHostMessage;

export function parseMcpBridgeMessage(raw: string): McpBridgeMessage | undefined {
  try {
    const parsed = JSON.parse(raw) as { type?: unknown };
    if (!parsed || typeof parsed !== "object" || typeof parsed.type !== "string") {
      return undefined;
    }
    return parsed as McpBridgeMessage;
  } catch {
    return undefined;
  }
}
